export default __webpack_public_path__ + "static/media/fast.8f659bec.svg";